var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaffManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 21.747 19.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-218.253 -257.332)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M230.375,262.092l-.691,2.4-.329-1.714.306-.69h-1.016l.306.69-.329,1.714-.691-2.4-1.7.624c-.12.3-.5,2.744-.5,2.744a18.356,18.356,0,0,0,3.418.38,12.135,12.135,0,0,0,3.418-.38s-.376-2.444-.5-2.744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M227.931,260.322c.218.658.6,1.109,1.223,1.109s1-.451,1.224-1.109c.19.015.324-.2.411-.495.133-.44-.009-.6-.2-.652v-.011h0a2.834,2.834,0,0,0-.04-.976.322.322,0,0,0-.263-.248,1.366,1.366,0,0,0-.938-.541c-1.274-.3-1.29.51-1.29.51h0s-.3-.07-.344.288a6.768,6.768,0,0,0,0,.966h0v.011c-.19.055-.332.212-.2.652C227.607,260.117,227.74,260.337,227.931,260.322Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M222.892,273.511l-.691,2.4-.329-1.714.306-.69h-1.015l.306.69-.329,1.714-.692-2.4-1.7.623c-.121.3-.5,2.744-.5,2.744a18.262,18.262,0,0,0,3.418.38,12.123,12.123,0,0,0,3.417-.38s-.376-2.444-.5-2.744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M220.448,271.74c.218.658.6,1.11,1.224,1.11s1.005-.452,1.223-1.11c.191.015.324-.2.411-.494.133-.441-.009-.6-.2-.653v-.01h0a2.815,2.815,0,0,0-.04-.977.322.322,0,0,0-.263-.247,1.364,1.364,0,0,0-.938-.542c-1.274-.3-1.289.511-1.289.511h0a.284.284,0,0,0-.345.288,7.077,7.077,0,0,0,0,.966h0v.011c-.19.055-.332.212-.2.652C220.124,271.535,220.257,271.755,220.448,271.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M237.8,273.511l-.691,2.4-.329-1.714.306-.69h-1.016l.307.69-.33,1.714-.691-2.4-1.7.623c-.121.3-.5,2.744-.5,2.744a18.272,18.272,0,0,0,3.419.38,12.123,12.123,0,0,0,3.417-.38s-.376-2.444-.5-2.744Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M235.36,271.74c.218.658.6,1.11,1.223,1.11s1.005-.452,1.224-1.11c.191.015.324-.2.411-.494.133-.441-.009-.6-.2-.653v-.01h0a2.839,2.839,0,0,0-.04-.977.322.322,0,0,0-.263-.247,1.364,1.364,0,0,0-.938-.542c-1.274-.3-1.289.511-1.289.511h0a.284.284,0,0,0-.345.288,6.768,6.768,0,0,0,0,.966h0v.011c-.19.055-.332.212-.2.652C235.036,271.535,235.169,271.755,235.36,271.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M222.129,266.669H221.3v-7.1a1.152,1.152,0,0,1,.947-1.065h4.32v.769h-4.142s-.355.118-.355.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M236.035,266.626h.828v-7.1a1.152,1.152,0,0,0-.946-1.065H231.6v.769h4.142s.355.118.355.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M227.277,270.041l-.355-.473.355-.355.473.355,1.065-.355.118-.71h.355l.118.71.947.473.71-.473.237.237-.355.71.355.947.71.118v.355l-.71.118-.355.947.355.71-.237.237-.592-.355-1.065.473-.118.71h-.355l-.237-.71-.947-.473-.592.355-.237-.237.355-.592-.355-.947-.71-.118v-.355l.592-.118.473-1.183"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M224.91,270.041a4.475,4.475,0,0,1,4.261-3.077,4.567,4.567,0,0,1,4.142,2.959h.71a4.751,4.751,0,0,0-4.852-3.669A5.194,5.194,0,0,0,224.2,269.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#5f5f5f",
    d: "M226.449,275.012l-.474.473a4.9,4.9,0,0,0,6.273,0l-.355-.591S229.052,276.906,226.449,275.012Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    fill: "#fff",
    cx: 1.42,
    cy: 1.42,
    r: 1.42,
    transform: "translate(227.632 270.041)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    fill: "#5f5f5f",
    cx: 0.71,
    cy: 0.71,
    r: 0.71,
    transform: "translate(228.342 270.752)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffManagement);
export default __webpack_public_path__ + "static/media/StaffManagement.bc2ac7246ad9b3e6e67a14dac9285b87.svg";
export { ForwardRef as ReactComponent };